import { render, staticRenderFns } from "./bill-edit.vue?vue&type=template&id=cdc5bc80&"
import script from "./bill-edit.vue?vue&type=script&lang=js&"
export * from "./bill-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports